module.exports = __webpack_public_path__ + "static/lost-time-ef793110a1b6efa5375c70488aa58f9e.jpg";